const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<p>
  I
  `);
                this.echo(this.include(context, this.source, `@cloudfour/components/icon/icon.twig`, new Map([[`name`, `heart`], [`title`, `love`], [`inline`, true]]), true, false, 3));
                this.echo(`  icons with semantic fallbacks.
</p>
<p>
  `);
                this.echo(this.include(context, this.source, `@cloudfour/components/icon/icon.twig`, new Map([[`name`, `check`], [`inline`, true]]), true, false, 11));
                this.echo(`  Decorative icons are nice, too!
</p>
`);
            }

            getTemplateName() {
                return `ec8f91a082d335e464ac3aa6c8eff49f900a484140090ff4476795eced51e50c`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `ec8f91a082d335e464ac3aa6c8eff49f900a484140090ff4476795eced51e50c`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'ec8f91a082d335e464ac3aa6c8eff49f900a484140090ff4476795eced51e50c');

let template = env.loadTemplate('ec8f91a082d335e464ac3aa6c8eff49f900a484140090ff4476795eced51e50c');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/icon/demo/a11y.twig", args: context }
     );
     return rendered;;
};